import { Injectable } from '@angular/core';
import { BLE } from "@ionic-native/ble";

@Injectable()

export class TestoBleService {

  public busy = false;

  private scanSeconds = 10;
  private serviceUuid = '2000';
  private charasteristicUuid = '3000';
  private targetDeviceName = 'testo 300';

  constructor(
    private ble: BLE
  ) {}

  public getData(callback?){
    return new Promise((resolve, reject) => {
      if(!this.busy){
        this.busy = true;
        this.start(callback).then((data) => {
          this.busy = false;
          resolve(data);
        }).catch((err) => {
          this.busy = false;
          reject(err);
        });
      } else {
        reject(0);
      }
    });
  }

  private start(callback?){
    return new Promise((resolve, reject) => {
      // Setup notFoundTimeout: Stop scanning after scanSeconds
      let notFoundTimeout = setTimeout(() => {
        this.ble.stopScan().then(() => {
          this.triggerCallback(callback, 'Geen Bluetooth apparaten gevonden', 0);
          reject(-1); // Scan failed
        });
      }, 1000 * this.scanSeconds);
      // Start scan
      this.triggerCallback(callback, 'Bezig met het zoeken naar Bluetooth apparaten...', 1);
      this.ble.startScanWithOptions([], {
        reportDuplicates: false
      }).subscribe((scanResult) => {
        if(scanResult.name){
          let name = scanResult.name.toLowerCase();
          if (name.indexOf(this.targetDeviceName.toLowerCase()) === 0) {
            // Clear notFoundTimeout
            if(notFoundTimeout){
              clearTimeout(notFoundTimeout);
            }
            //
            let deviceId = scanResult.id;
            let deviceName = scanResult.name;
            // Stop scan
            this.ble.stopScan().then(() => {
              // Connect
              this.triggerCallback(callback, 'Bezig met verbinden met \'' + deviceName + '\'...', 2);
              this.ble.connect(deviceId).subscribe((connectResult) => {
                this.triggerCallback(callback, 'Bezig met configureren van de verbinding...', 3);
                // Configure connection
                this.ble.requestMtu(deviceId, 23).then(() => {
                  this.triggerCallback(callback, 'Bezig met het lezen van gegevens...', 4);
                  if(connectResult.characteristics && connectResult.characteristics.length > 0){
                    // Read data
                    this.readBleData(deviceId, connectResult.characteristics, callback).then((result: string) => {
                      this.ble.disconnect(deviceId).then(() => {
                        this.triggerCallback(callback, 'Klaar!',100);
                        console.log(result);
                        resolve(JSON.parse(result));
                      }).catch(() => {
                        this.triggerCallback(callback, 'Verbinding verbreken mislukt', 0);
                        reject(-7);
                      });
                    }).catch((err) => {
                      this.triggerCallback(callback, 'Lezen van gegevens mislukt', 0);
                      this.ble.disconnect(deviceId).then(() => {
                        reject(err); // readBleData error
                      });
                    });
                  } else {
                    this.triggerCallback(callback, 'Lezen van gegevens mislukt', 0);
                    this.ble.disconnect(deviceId).then(() => {
                      reject(-5); // Characteristics error
                    });
                  }
                }).catch((error) => {
                  this.triggerCallback(callback, 'Verbinding configureren mislukt', 0);
                  this.ble.disconnect(deviceId).then(() => {
                    reject(-4); // requestMtu error
                  });
                })
              }, (err) => {
                this.triggerCallback(callback, 'Verbinding mislukt', 0);
                reject(-3); // Connect error
              });
            }).catch((err) => {
              this.triggerCallback(callback, 'Zoeken naar apparaten mislukt', 0);
              reject(-2); // StopScan failed
            })
          }
        }
      }, (err) => {
        // Clear notFoundTimeout
        if(notFoundTimeout){
          clearTimeout(notFoundTimeout);
        }
        // Report error
        this.triggerCallback(callback, 'Zoeken naar apparaten mislukt', 0);
        reject(-1); // Scan failed
      });
    });
  }

  private triggerCallback(callback, text, progress){
    if(callback){
      callback(text, progress);
    }
  }

  private arrayBufferToString(input){
    return String.fromCharCode.apply(null, new Uint8Array(input));
  }

  private readBleData(deviceId, characteristics: Array<any>, callback?){
    return new Promise((resolve, reject) => {
      this.ble.read(deviceId, this.serviceUuid, this.charasteristicUuid).then((rawCount) => {
        let count = parseInt(this.arrayBufferToString(rawCount), 10);
        let i = 0;
        let data = [];
        let promises = [];
        characteristics.forEach((item) => {
          if(item.service != this.serviceUuid){
            return;
          }
          if(item.characteristic == this.charasteristicUuid){
            return;
          }
          i++;
          if(i > count){
            return;
          }
          let promise = this.ble.read(deviceId, item.service, item.characteristic).then((rawValue) => {
            let value = this.arrayBufferToString(rawValue);
            data.push({
              characteristic: item.characteristic,
              value: value
            });
            let percentage = Math.round(100 / count * data.length);
            this.triggerCallback(callback, 'Bezig met het lezen van gegevens...', percentage);
          });
          promises.push(promise);
        });
        Promise.all(promises).then(() => {
          data.sort((a, b) => {
            if (a.characteristic < b.characteristic){
              return -1;
            }
            if (a.characteristic > b.characteristic){
              return 1;
            }
            return 0;
          });
          let output = '';
          data.forEach((item) => {
            output += item.value;
          });
          console.log(data);
          console.log(output);
          resolve(output);
        }).catch((err) => {
          reject(err);
        });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  public startScan(){
    return this.ble.startScanWithOptions([], {
      reportDuplicates: false
    });
  }

  public stopScan(): Promise<any>{
    return this.ble.stopScan();
  }

}



// WEBPACK FOOTER //
// ./src/services/testo-ble.service.ts